import { useState } from "react";
import SmartImg from "./SmartImg";

/** id: YouTube video id (e.g. "dQw4w9WgXcQ") */
export default function LiteYouTube({ id, title = "YouTube video" }) {
  const [play, setPlay] = useState(false);
  const thumb = `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;

  if (play) {
    return (
      <iframe
        title={title}
        src={`https://www.youtube.com/embed/${id}?autoplay=1&rel=0`}
        className="absolute inset-0 h-full w-full"
        loading="lazy"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    );
  }

  return (
    <button
      type="button"
      onClick={() => setPlay(true)}
      className="group absolute inset-0 w-full h-full"
      aria-label={`Play ${title}`}
    >
      <SmartImg
        src={thumb}
        alt={title}
        className="w-full h-full object-cover"
        width={1280}
        height={720}
      />
      <span className="absolute inset-0 grid place-items-center">
        <span className="h-14 w-14 rounded-full bg-black/60 backdrop-blur-sm grid place-items-center group-hover:bg-black/70 transition">
          ▶
        </span>
      </span>
    </button>
  );
}
